import React, { Component } from 'react'
import InputRow from './InputRow'
import PropTypes from 'prop-types'
export default class HealthInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      illness: this.props.illnessDescription || '',
      error: '',
      hasIllness: this.props.hasBeenIll || false,

    }
  }

  render () {
    const validationError = this.props.error
    const {
      illness,
      hasIllness
    } = this.state
    let ill = hasIllness
    if (ill === 'True' || ill === 'False') {
      const ills = ill.toLowerCase()
      if (ills === 'true') ill = true
      else ill = false
    }

    return (
      <div>
        <div className="illness-part">
          <p>Please advise if your case will be needing any additional support due to special learning needs or challenges?</p>
          Yes<input type="radio" value={hasIllness} onChange={() => {
            this.setState({ hasIllness: true })
            this.props.collectState('HI', {
              illness: illness,
              hasIllness: true
            })
          }} name="illness" checked={!!ill} style={{ minWidth: 'auto', marginLeft: 5 }}/>
          No<input type="radio" value={hasIllness} onChange={() => {
            this.setState({ hasIllness: false })
            this.props.collectState('HI', {
              illness: illness,
              hasIllness: false
            })
          }} name="illness" checked={!ill} style={{ minWidth: 'auto', marginLeft: 5 }}/>
        </div>
        <InputRow
          name="text"
          rowName="If yes, specify"  
        //  value= {illness} 
         value = {!hasIllness || hasIllness == "False" ? '' : illness }
          disabled= {!hasIllness || hasIllness == "False" ? true : false}
          onChange={(e) => {
            this.setState({ illness: e })
            this.props.collectState('HI', {
              illness: e,
              hasIllness: hasIllness,
            })
          }}
          required={!hasIllness || hasIllness == "False" ? null : '*'}
          errMsg={validationError.illness ? validationError.illness : ''}
        />

        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}
HealthInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  illnessDescription: PropTypes.string,
  hasBeenIll: PropTypes.bool,
  collectState: PropTypes.func,
  error: PropTypes.object
}
